import React from 'react'
import GetNavList from '../Navigation/NavList'
import { Link } from 'gatsby'
import config from '../../../data/SiteConfig'
import './not-found.scss'

export default NotFound => {
  return (
    <div className="not-found-page">
      <div className="not-found-page-contents">
        <h6>Looking for any of these?</h6>
        <ul className="nav-list">
          {GetNavList(config).map((value, index) => {
            return (
              <li key={index}>
                <Link key={index} to={value.to} alt={value.primaryText}>
                  {value.primaryText}
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
